import { useTranslation } from 'libs/i18n';

import { Field, useField } from '../../forms/orderForm';
import { useManagersForOrder } from '../../hooks/useManagersForOrder';

export const ManagerAutocompleteFeature = () => {
  const { t } = useTranslation();

  const { field } = useField('manager');

  const { managers, loading: managersLoading } = useManagersForOrder();

  return (
    <Field.Autocomplete
      key={field.value?.id}
      fullWidth
      label={t('order.sections.executionHistorySection.fields.manager.label')}
      loading={managersLoading}
      name="manager"
      optionLabelKey="name"
      options={managers}
      optionValueKey="id"
      placeholder={t(
        'order.sections.executionHistorySection.fields.manager.placeholder'
      )}
    />
  );
};
